import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  Label,
  Spinner,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_Newbook,
  API_Partner_Newbook,
} from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
export default function NewbookIntegration({ visible, toggle, id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [rateAssignments, setRatesAssignments] = useState([]);
  const [selectedRateAssignments, setSelectedRateAssignments] = useState([]);
  const [property, setProperty] = useState([]);
  const [selectedproperty, setSeletedProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [maskData, setMaskData] = useState({ instanceName: '' });
  const [inputData, setInputData] = useState({
    groupId: getGroupID(),
    name: '',
    channel: 'NewbookBookingEngine',
    level: 'Group',
    properties: [],
    sessionTimeoutInSeconds: 120,
    username: '',
    password: '',
    region: '',
    baseUrl: '',
    instanceName: '',
    disabled: false,
  });

  const handleSelectChange = (selectedAssignments) => {
    setSelectedRateAssignments(selectedAssignments);
  };

  useEffect(() => {
    if (id !== undefined) {
      setIsLoading(true);
      AxiosAPI({
        method: 'get',
        url: `${API_Newbook}/${id}/newbook?groupId=${getGroupID()}`,
      })
        .then((res) => {
          const data = res.data;
          let filterList = [];
          if (data.properties && Array.isArray(data.properties)) {
            filterList = data.properties
              .filter((elem) => elem !== undefined && elem !== null)
              .map(String);
          }
          let obj = {
            groupId: data.groupId,
            name: data.name || '',
            channel: data.channel || 'NewbookBookingEngine',
            level: data.level || 'Group',
            properties: filterList,
            sessionTimeoutInSeconds: data.sessionTimeoutInSeconds || 120,
            username: data.channelDetails?.username || '',
            password: data.channelDetails?.password || '',
            region: data.channelDetails?.region || '',
            baseUrl: data.channelDetails?.baseUrl || '',
            disabled: data.disabled || false,
          };
          setIsLoading(true);
          AxiosAPI({
            method: 'post',
            data: {
              baseUrl: data.channelDetails?.baseUrl,
              username: data.channelDetails?.username,
              password: data.channelDetails?.password,
              region: data.channelDetails?.region,
            },
            url: `${API_Partner_Newbook}/instance-details`,
          })
            .then((res) => {
              if (res.data.data !== undefined) {
                const apiKey = Object.keys(res.data.data)[0];
                obj.instanceName = apiKey;

                setMaskData({
                  ...maskData,
                  password: mask(data?.channelDetails?.password),
                  instanceName: mask(apiKey),
                });
                AxiosAPI({
                  method: 'post',
                  data: {
                    baseUrl: data.channelDetails?.baseUrl,
                    username: data.channelDetails?.username,
                    password: data.channelDetails?.password,
                    region: data.channelDetails?.region,
                    apiKey: apiKey,
                  },
                  url: `${API_Partner_Newbook}/tariffs`,
                }).then((json) => {
                  let lst = [];
                  let selectedRates = [];
                  json.data.map((m) => {
                    if (lst.filter((f) => f.id === m.id).length == 0)
                      lst.push({
                        key: m.id,
                        label: m.name + ' - ' + m.id,
                        value: m.id,
                      });
                  });
                  setRatesAssignments(lst);
                  if (
                    data?.channelDetails?.ratePlans &&
                    data?.channelDetails?.ratePlans.length > 0
                  ) {
                    data.channelDetails?.ratePlans.map((m) => {
                      if (lst.filter((f) => f.value == m).length > 0) {
                        let rateObj = lst.filter((f) => f.value === m)[0];
                        selectedRates.push(rateObj);
                      }
                    });
                  }
                  setSelectedRateAssignments(selectedRates);                  
                  setIsLoading(false);
                });
              }
            })
            .catch(() => setIsLoading(false));          
          setSeletedProperty(filterList);
          setInputData(obj);          
        })
        .catch(() => setIsLoading(false));
    }
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    })
      .then((res) => {
        let list = [];
        if (Array.isArray(res.data)) {
          list = res.data;
        } else if (Array.isArray(res.data?.data)) {
          list = res.data.data;
        } else if (Array.isArray(res.data?.properties)) {
          list = res.data.properties;
        }
        setProperty(list);
      })
      .catch((err) => console.error(err));
  }, [id]);

  useEffect(() => {
    if (id === undefined) {
      if (
        inputData?.baseUrl !== '' &&
        inputData?.username !== '' &&
        inputData?.password !== '' &&
        inputData?.region !== ''
      ) {
        const extractData = async () => {
          extractInstancename(inputData);
        };
        extractData();
      }
    }
  }, [inputData]);

  const extractInstancename = (jsonDetails) => {
    setIsLoading(true);
    AxiosAPI({
      method: 'post',
      data: {
        baseUrl: jsonDetails?.baseUrl,
        username: jsonDetails?.username,
        password: jsonDetails?.password,
        region: jsonDetails?.region,
      },
      url: `${API_Partner_Newbook}/instance-details`,
    })
      .then((res) => {
        if (res.data.data !== undefined) {
          const apiKey = Object.keys(res.data.data)[0];
          setInputData({
            ...inputData,
            instanceName: apiKey,
          });
          setMaskData({
            ...maskData,
            instanceName: apiKey,
          });
          AxiosAPI({
            method: 'post',
            data: {
              baseUrl: jsonDetails?.baseUrl,
              username: jsonDetails?.username,
              password: jsonDetails?.password,
              region: jsonDetails?.region,
              apiKey: apiKey,
            },
            url: `${API_Partner_Newbook}/tariffs`,
          }).then((json) => {
            let lst = [];
            let selectedRates = [];
            json.data.map((m) => {
              if (lst.filter((f) => f.id === m.id).length == 0)
                lst.push({
                  key: m.id,
                  label: m.name + ' - ' + m.id,
                  value: m.id,
                });
            });
            setRatesAssignments(lst);
            setSelectedRateAssignments(selectedRates);
            setIsLoading(false);
          });
        }
      })
      .catch(() => setIsLoading(false));
  };

  const handleSave = () => {
    if (!inputData.username || !inputData.password) return;
    let body = inputData;
    body.ratePlans = selectedRateAssignments.map((s) => s.value);
    if (id !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${API_Newbook}/${id}/newbook?groupId=${getGroupID()}`,
        data: body,
      }).then(() => {
        toggle();
        setTimeout(() => {
          window.location.reload();
        }, 300);
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: `${API_Newbook}/newbook`,
        data: body,
      }).then((res) => {
        if (
          res.data?.HttpStatusCode === 400 &&
          res.data?.Messages?.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        setTimeout(() => {
          window.location.reload();
        }, 300);
      });
    }
  };

  const handleCheckChange = (e) => {
    const value = String(e.target.value);
    let updatedList = [];
    if (selectedproperty.includes(value)) {
      updatedList = selectedproperty.filter((item) => item !== value);
    } else {
      updatedList = [...selectedproperty, value];
    }
    setSeletedProperty(updatedList);
    setInputData({ ...inputData, properties: updatedList });
  };

  const handleChange = (e) => {
    setInputData({
      ...inputData,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === 'password') {
      setMaskData({
        ...maskData,
        password: mask(e.target.value),
      });
    }
    if (e.target.name === 'username' && id !== undefined)
      extractInstancename({
        usrrname: e.target.value,
        password: inputData.password,
        region: inputData.region,
        baseUrl: inputData.baseUrl,
      });
    if (e.target.name === 'password' && id !== undefined)
      extractInstancename({
        usrrname: inputData.username,
        password: e.target.value,
        region: inputData.region,
        baseUrl: inputData.baseUrl,
      });
    if (e.target.name === 'baseUrl' && id !== undefined)
      extractInstancename({
        usrrname: inputData.username,
        password: inputData.password,
        region: inputData.region,
        baseUrl: e.target.value,
      });
    if (e.target.name === 'region' && id !== undefined)
      extractInstancename({
        usrrname: inputData.username,
        password: inputData.password,
        region: e.target.value,
        baseUrl: inputData.baseUrl,
      });
  };

  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="md">
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>Add Integration</h6>
                <Separator className="mb-3" />

                <FormGroup className="mb-2 text-left">
                  <Label>Integration Name</Label>
                  <Input
                    name="name"
                    defaultValue={inputData.name}
                    onChange={handleChange}
                  />
                </FormGroup>
                <FormGroup className="mb-2 text-left">
                  <Label>Username</Label>
                  <Input
                    name="username"
                    defaultValue={inputData.username}
                    onChange={handleChange}
                  />
                </FormGroup>
                <FormGroup className="mb-2 text-left">
                  <Label>Password</Label>
                  <Input
                    type="text"
                    name="password"
                    defaultValue={inputData.password}
                    onChange={handleChange}
                  />
                </FormGroup>
                <FormGroup className="mb-2 text-left">
                  <Label>Base URL</Label>
                  <Input
                    name="baseUrl"
                    defaultValue={inputData.baseUrl}
                    onChange={handleChange}
                  />
                </FormGroup>
                <FormGroup className="mb-2 text-left">
                  <Label>Region</Label>
                  <Input
                    name="region"
                    defaultValue={inputData.region}
                    onChange={handleChange}
                  />
                </FormGroup>
                {isLoading ? (
                  <div className="text-center">
                    <Spinner color="primary" className="mb-1" />
                  </div>
                ) : (
                  <Fragment>
                    <FormGroup className="mb-2 text-left d-none">
                      <Label>Instance Name</Label>
                      <Input
                        name="instanceName"
                        defaultValue={maskData.instanceName}
                        onChange={handleChange}
                      />
                    </FormGroup>
                    {rateAssignments !== undefined &&
                      rateAssignments.length > 0 && (
                        <FormGroup className="mb-2 text-left">
                          <Label>Rates</Label>
                          <Select
                            components={{ Input: CustomSelectInput }}
                            className="react-select"
                            classNamePrefix="react-select"
                            isMulti={true}
                            name="form-field-name"
                            value={selectedRateAssignments}
                            onChange={handleSelectChange}
                            options={rateAssignments}
                          ></Select>
                        </FormGroup>
                      )}
                  </Fragment>
                )}
                <FormGroup>
                  <div className="integration-property">
                    {property.map((p, index) => {
                      return (
                        <CustomInput
                          key={p.id}
                          type="checkbox"
                          id={index}
                          label={p.name}
                          value={String(p.id)}
                          onChange={handleCheckChange}
                          checked={inputData.properties.includes(String(p.id))}
                        />
                      );
                    })}
                  </div>
                </FormGroup>

                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      {' '}
                      Create New Integration{' '}
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      {' '}
                      Update Integration{' '}
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    {' '}
                    Cancel{' '}
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>

      <Validation open={open} messages={msg} toggle={() => setOpen(!open)} />
    </Fragment>
  );
}
